module.exports = __webpack_public_path__ + "static/media/corduff-travel.b1af38e6.webp";